/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./client/routes/__root"
import { Route as protectedRouteRouteImport } from "./client/routes/(protected)/route"
import { Route as IndexRouteImport } from "./client/routes/index"
import { Route as protectedSettingsRouteRouteImport } from "./client/routes/(protected)/settings/route"
import { Route as protectedMapRouteRouteImport } from "./client/routes/(protected)/map/route"
import { Route as protectedSettingsIndexRouteImport } from "./client/routes/(protected)/settings/index"
import { Route as protectedMapIndexRouteImport } from "./client/routes/(protected)/map/index"
import { Route as protectedSettingsSkopaIndexRouteImport } from "./client/routes/(protected)/settings/skopa/index"
import { Route as protectedSettingsMapIndexRouteImport } from "./client/routes/(protected)/settings/map/index"
import { Route as protectedSettingsChannelsIndexRouteImport } from "./client/routes/(protected)/settings/channels/index"
import { Route as protectedSettingsAdminIndexRouteImport } from "./client/routes/(protected)/settings/admin/index"
import { Route as protectedMapSkopaIndexRouteImport } from "./client/routes/(protected)/map/skopa/index"
import { Route as protectedMapPdarIndexRouteImport } from "./client/routes/(protected)/map/pdar/index"
import { Route as protectedMapHiraIndexRouteImport } from "./client/routes/(protected)/map/hira/index"
import { Route as protectedSettingsSkopaViewRouteImport } from "./client/routes/(protected)/settings/skopa/view"
import { Route as protectedSettingsSkopaLogsRouteImport } from "./client/routes/(protected)/settings/skopa/logs"
import { Route as protectedSettingsSkopaDocsRouteImport } from "./client/routes/(protected)/settings/skopa/docs"
import { Route as protectedSettingsSkopaConfigRouteImport } from "./client/routes/(protected)/settings/skopa/config"
import { Route as protectedSettingsAdminNewUserIndexRouteImport } from "./client/routes/(protected)/settings/admin/new-user/index"

const protectedRouteRoute = protectedRouteRouteImport.update({
  id: "/(protected)",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const protectedSettingsRouteRoute = protectedSettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedMapRouteRoute = protectedMapRouteRouteImport.update({
  id: "/map",
  path: "/map",
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSettingsIndexRoute = protectedSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedMapIndexRoute = protectedMapIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => protectedMapRouteRoute,
} as any)
const protectedSettingsSkopaIndexRoute =
  protectedSettingsSkopaIndexRouteImport.update({
    id: "/skopa/",
    path: "/skopa/",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsMapIndexRoute =
  protectedSettingsMapIndexRouteImport.update({
    id: "/map/",
    path: "/map/",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsChannelsIndexRoute =
  protectedSettingsChannelsIndexRouteImport.update({
    id: "/channels/",
    path: "/channels/",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsAdminIndexRoute =
  protectedSettingsAdminIndexRouteImport.update({
    id: "/admin/",
    path: "/admin/",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedMapSkopaIndexRoute = protectedMapSkopaIndexRouteImport.update({
  id: "/skopa/",
  path: "/skopa/",
  getParentRoute: () => protectedMapRouteRoute,
} as any)
const protectedMapPdarIndexRoute = protectedMapPdarIndexRouteImport.update({
  id: "/pdar/",
  path: "/pdar/",
  getParentRoute: () => protectedMapRouteRoute,
} as any)
const protectedMapHiraIndexRoute = protectedMapHiraIndexRouteImport.update({
  id: "/hira/",
  path: "/hira/",
  getParentRoute: () => protectedMapRouteRoute,
} as any)
const protectedSettingsSkopaViewRoute =
  protectedSettingsSkopaViewRouteImport.update({
    id: "/skopa/view",
    path: "/skopa/view",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSkopaLogsRoute =
  protectedSettingsSkopaLogsRouteImport.update({
    id: "/skopa/logs",
    path: "/skopa/logs",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSkopaDocsRoute =
  protectedSettingsSkopaDocsRouteImport.update({
    id: "/skopa/docs",
    path: "/skopa/docs",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSkopaConfigRoute =
  protectedSettingsSkopaConfigRouteImport.update({
    id: "/skopa/config",
    path: "/skopa/config",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsAdminNewUserIndexRoute =
  protectedSettingsAdminNewUserIndexRouteImport.update({
    id: "/admin/new-user/",
    path: "/admin/new-user/",
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/map": typeof protectedMapRouteRouteWithChildren
  "/settings": typeof protectedSettingsRouteRouteWithChildren
  "/map/": typeof protectedMapIndexRoute
  "/settings/": typeof protectedSettingsIndexRoute
  "/settings/skopa/config": typeof protectedSettingsSkopaConfigRoute
  "/settings/skopa/docs": typeof protectedSettingsSkopaDocsRoute
  "/settings/skopa/logs": typeof protectedSettingsSkopaLogsRoute
  "/settings/skopa/view": typeof protectedSettingsSkopaViewRoute
  "/map/hira": typeof protectedMapHiraIndexRoute
  "/map/pdar": typeof protectedMapPdarIndexRoute
  "/map/skopa": typeof protectedMapSkopaIndexRoute
  "/settings/admin": typeof protectedSettingsAdminIndexRoute
  "/settings/channels": typeof protectedSettingsChannelsIndexRoute
  "/settings/map": typeof protectedSettingsMapIndexRoute
  "/settings/skopa": typeof protectedSettingsSkopaIndexRoute
  "/settings/admin/new-user": typeof protectedSettingsAdminNewUserIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/map": typeof protectedMapIndexRoute
  "/settings": typeof protectedSettingsIndexRoute
  "/settings/skopa/config": typeof protectedSettingsSkopaConfigRoute
  "/settings/skopa/docs": typeof protectedSettingsSkopaDocsRoute
  "/settings/skopa/logs": typeof protectedSettingsSkopaLogsRoute
  "/settings/skopa/view": typeof protectedSettingsSkopaViewRoute
  "/map/hira": typeof protectedMapHiraIndexRoute
  "/map/pdar": typeof protectedMapPdarIndexRoute
  "/map/skopa": typeof protectedMapSkopaIndexRoute
  "/settings/admin": typeof protectedSettingsAdminIndexRoute
  "/settings/channels": typeof protectedSettingsChannelsIndexRoute
  "/settings/map": typeof protectedSettingsMapIndexRoute
  "/settings/skopa": typeof protectedSettingsSkopaIndexRoute
  "/settings/admin/new-user": typeof protectedSettingsAdminNewUserIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/(protected)": typeof protectedRouteRouteWithChildren
  "/(protected)/map": typeof protectedMapRouteRouteWithChildren
  "/(protected)/settings": typeof protectedSettingsRouteRouteWithChildren
  "/(protected)/map/": typeof protectedMapIndexRoute
  "/(protected)/settings/": typeof protectedSettingsIndexRoute
  "/(protected)/settings/skopa/config": typeof protectedSettingsSkopaConfigRoute
  "/(protected)/settings/skopa/docs": typeof protectedSettingsSkopaDocsRoute
  "/(protected)/settings/skopa/logs": typeof protectedSettingsSkopaLogsRoute
  "/(protected)/settings/skopa/view": typeof protectedSettingsSkopaViewRoute
  "/(protected)/map/hira/": typeof protectedMapHiraIndexRoute
  "/(protected)/map/pdar/": typeof protectedMapPdarIndexRoute
  "/(protected)/map/skopa/": typeof protectedMapSkopaIndexRoute
  "/(protected)/settings/admin/": typeof protectedSettingsAdminIndexRoute
  "/(protected)/settings/channels/": typeof protectedSettingsChannelsIndexRoute
  "/(protected)/settings/map/": typeof protectedSettingsMapIndexRoute
  "/(protected)/settings/skopa/": typeof protectedSettingsSkopaIndexRoute
  "/(protected)/settings/admin/new-user/": typeof protectedSettingsAdminNewUserIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/map"
    | "/settings"
    | "/map/"
    | "/settings/"
    | "/settings/skopa/config"
    | "/settings/skopa/docs"
    | "/settings/skopa/logs"
    | "/settings/skopa/view"
    | "/map/hira"
    | "/map/pdar"
    | "/map/skopa"
    | "/settings/admin"
    | "/settings/channels"
    | "/settings/map"
    | "/settings/skopa"
    | "/settings/admin/new-user"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/map"
    | "/settings"
    | "/settings/skopa/config"
    | "/settings/skopa/docs"
    | "/settings/skopa/logs"
    | "/settings/skopa/view"
    | "/map/hira"
    | "/map/pdar"
    | "/map/skopa"
    | "/settings/admin"
    | "/settings/channels"
    | "/settings/map"
    | "/settings/skopa"
    | "/settings/admin/new-user"
  id:
    | "__root__"
    | "/"
    | "/(protected)"
    | "/(protected)/map"
    | "/(protected)/settings"
    | "/(protected)/map/"
    | "/(protected)/settings/"
    | "/(protected)/settings/skopa/config"
    | "/(protected)/settings/skopa/docs"
    | "/(protected)/settings/skopa/logs"
    | "/(protected)/settings/skopa/view"
    | "/(protected)/map/hira/"
    | "/(protected)/map/pdar/"
    | "/(protected)/map/skopa/"
    | "/(protected)/settings/admin/"
    | "/(protected)/settings/channels/"
    | "/(protected)/settings/map/"
    | "/(protected)/settings/skopa/"
    | "/(protected)/settings/admin/new-user/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/(protected)": {
      id: "/(protected)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(protected)/settings": {
      id: "/(protected)/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof protectedSettingsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    "/(protected)/map": {
      id: "/(protected)/map"
      path: "/map"
      fullPath: "/map"
      preLoaderRoute: typeof protectedMapRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    "/(protected)/settings/": {
      id: "/(protected)/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof protectedSettingsIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/map/": {
      id: "/(protected)/map/"
      path: "/"
      fullPath: "/map/"
      preLoaderRoute: typeof protectedMapIndexRouteImport
      parentRoute: typeof protectedMapRouteRoute
    }
    "/(protected)/settings/skopa/": {
      id: "/(protected)/settings/skopa/"
      path: "/skopa"
      fullPath: "/settings/skopa"
      preLoaderRoute: typeof protectedSettingsSkopaIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/map/": {
      id: "/(protected)/settings/map/"
      path: "/map"
      fullPath: "/settings/map"
      preLoaderRoute: typeof protectedSettingsMapIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/channels/": {
      id: "/(protected)/settings/channels/"
      path: "/channels"
      fullPath: "/settings/channels"
      preLoaderRoute: typeof protectedSettingsChannelsIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/admin/": {
      id: "/(protected)/settings/admin/"
      path: "/admin"
      fullPath: "/settings/admin"
      preLoaderRoute: typeof protectedSettingsAdminIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/map/skopa/": {
      id: "/(protected)/map/skopa/"
      path: "/skopa"
      fullPath: "/map/skopa"
      preLoaderRoute: typeof protectedMapSkopaIndexRouteImport
      parentRoute: typeof protectedMapRouteRoute
    }
    "/(protected)/map/pdar/": {
      id: "/(protected)/map/pdar/"
      path: "/pdar"
      fullPath: "/map/pdar"
      preLoaderRoute: typeof protectedMapPdarIndexRouteImport
      parentRoute: typeof protectedMapRouteRoute
    }
    "/(protected)/map/hira/": {
      id: "/(protected)/map/hira/"
      path: "/hira"
      fullPath: "/map/hira"
      preLoaderRoute: typeof protectedMapHiraIndexRouteImport
      parentRoute: typeof protectedMapRouteRoute
    }
    "/(protected)/settings/skopa/view": {
      id: "/(protected)/settings/skopa/view"
      path: "/skopa/view"
      fullPath: "/settings/skopa/view"
      preLoaderRoute: typeof protectedSettingsSkopaViewRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/skopa/logs": {
      id: "/(protected)/settings/skopa/logs"
      path: "/skopa/logs"
      fullPath: "/settings/skopa/logs"
      preLoaderRoute: typeof protectedSettingsSkopaLogsRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/skopa/docs": {
      id: "/(protected)/settings/skopa/docs"
      path: "/skopa/docs"
      fullPath: "/settings/skopa/docs"
      preLoaderRoute: typeof protectedSettingsSkopaDocsRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/skopa/config": {
      id: "/(protected)/settings/skopa/config"
      path: "/skopa/config"
      fullPath: "/settings/skopa/config"
      preLoaderRoute: typeof protectedSettingsSkopaConfigRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    "/(protected)/settings/admin/new-user/": {
      id: "/(protected)/settings/admin/new-user/"
      path: "/admin/new-user"
      fullPath: "/settings/admin/new-user"
      preLoaderRoute: typeof protectedSettingsAdminNewUserIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
  }
}

interface protectedMapRouteRouteChildren {
  protectedMapIndexRoute: typeof protectedMapIndexRoute
  protectedMapHiraIndexRoute: typeof protectedMapHiraIndexRoute
  protectedMapPdarIndexRoute: typeof protectedMapPdarIndexRoute
  protectedMapSkopaIndexRoute: typeof protectedMapSkopaIndexRoute
}

const protectedMapRouteRouteChildren: protectedMapRouteRouteChildren = {
  protectedMapIndexRoute: protectedMapIndexRoute,
  protectedMapHiraIndexRoute: protectedMapHiraIndexRoute,
  protectedMapPdarIndexRoute: protectedMapPdarIndexRoute,
  protectedMapSkopaIndexRoute: protectedMapSkopaIndexRoute,
}

const protectedMapRouteRouteWithChildren =
  protectedMapRouteRoute._addFileChildren(protectedMapRouteRouteChildren)

interface protectedSettingsRouteRouteChildren {
  protectedSettingsIndexRoute: typeof protectedSettingsIndexRoute
  protectedSettingsSkopaConfigRoute: typeof protectedSettingsSkopaConfigRoute
  protectedSettingsSkopaDocsRoute: typeof protectedSettingsSkopaDocsRoute
  protectedSettingsSkopaLogsRoute: typeof protectedSettingsSkopaLogsRoute
  protectedSettingsSkopaViewRoute: typeof protectedSettingsSkopaViewRoute
  protectedSettingsAdminIndexRoute: typeof protectedSettingsAdminIndexRoute
  protectedSettingsChannelsIndexRoute: typeof protectedSettingsChannelsIndexRoute
  protectedSettingsMapIndexRoute: typeof protectedSettingsMapIndexRoute
  protectedSettingsSkopaIndexRoute: typeof protectedSettingsSkopaIndexRoute
  protectedSettingsAdminNewUserIndexRoute: typeof protectedSettingsAdminNewUserIndexRoute
}

const protectedSettingsRouteRouteChildren: protectedSettingsRouteRouteChildren =
  {
    protectedSettingsIndexRoute: protectedSettingsIndexRoute,
    protectedSettingsSkopaConfigRoute: protectedSettingsSkopaConfigRoute,
    protectedSettingsSkopaDocsRoute: protectedSettingsSkopaDocsRoute,
    protectedSettingsSkopaLogsRoute: protectedSettingsSkopaLogsRoute,
    protectedSettingsSkopaViewRoute: protectedSettingsSkopaViewRoute,
    protectedSettingsAdminIndexRoute: protectedSettingsAdminIndexRoute,
    protectedSettingsChannelsIndexRoute: protectedSettingsChannelsIndexRoute,
    protectedSettingsMapIndexRoute: protectedSettingsMapIndexRoute,
    protectedSettingsSkopaIndexRoute: protectedSettingsSkopaIndexRoute,
    protectedSettingsAdminNewUserIndexRoute:
      protectedSettingsAdminNewUserIndexRoute,
  }

const protectedSettingsRouteRouteWithChildren =
  protectedSettingsRouteRoute._addFileChildren(
    protectedSettingsRouteRouteChildren,
  )

interface protectedRouteRouteChildren {
  protectedMapRouteRoute: typeof protectedMapRouteRouteWithChildren
  protectedSettingsRouteRoute: typeof protectedSettingsRouteRouteWithChildren
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedMapRouteRoute: protectedMapRouteRouteWithChildren,
  protectedSettingsRouteRoute: protectedSettingsRouteRouteWithChildren,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  protectedRouteRoute: protectedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
